import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';

import {persistRTKQReducer} from 'features/rtkq-persist';

import {addressApi} from './addressApi';
import {catalogueApi} from './catalogueApi';
import {importApi} from './importApi';
import {omneticApi} from './omneticApi';
import {omneticToolsApi} from './omneticToolsApi';
import {priceReportApi} from './priceReportApi';

const persistedCatalogueReducer = persistRTKQReducer(
  {
    key: catalogueApi.reducerPath,
  },
  catalogueApi.reducer
);

export const reducers = {
  [priceReportApi.reducerPath]: priceReportApi.reducer,
  [catalogueApi.reducerPath]: persistedCatalogueReducer,
  [importApi.reducerPath]: importApi.reducer,
  [addressApi.reducerPath]: addressApi.reducer,
  [omneticApi.reducerPath]: omneticApi.reducer,
  [omneticToolsApi.reducerPath]: omneticToolsApi.reducer,
};

export const store = configureStore({
  // Add the generated reducer as a specific top-level slice
  reducer: reducers,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      priceReportApi.middleware,
      catalogueApi.middleware,
      importApi.middleware,
      addressApi.middleware,
      omneticApi.middleware,
      omneticToolsApi.middleware
    ),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
